export const firebaseConfig = {
	apiKey: 'AIzaSyAHdzfLfPd5elSH7ZJQLR4MKYCFG__Z7ME',
	// authDomain: 'coral-web-ffcb8.firebaseapp.com',
	authDomain: 'leita.app',
	databaseURL: 'https://coral-web-ffcb8.firebaseio.com',
	projectId: 'coral-web-ffcb8',
	storageBucket: 'coral-web-ffcb8.appspot.com',
	messagingSenderId: '476590391556"'
}

export const config = {
	extensionId: 'galigneggpjdojmmaphdmnipndgdgabd',
	extension_url: 'https://chrome.google.com/webstore/detail/coral-web-extension/galigneggpjdojmmaphdmnipndgdgabd'
}